import Service from './Service';

/**
 * Classe utilizada para tratar regras de negócio e manipular o retorno dos webservices
 */
class LoginService extends Service {

    async buscarOrgaosJulgadoresColegiados() {
        return this.getLoginApi().buscarOrgaosJulgadoresColegiados();
    }

    async recuperarDetalhesUsuarioLogado() {
        return this.getLoginApi().recuperarDetalhesUsuarioLogado();
    }
}

export default LoginService;
